export type TilesErrorCode =
  | 'invalid-input'
  | 'unsupported-version'
  | 'unsupported-capability'
  | 'unsupported-content'
  | 'invalid-resource'
  | 'http-error'
  | 'cancelled'
  | 'limit-exceeded'
  | 'hierarchy-cycle'
  | 'budget-exceeded'
  | 'invalid-handle'
  | 'disposed'
  | 'resource-release'
  | 'image-worker-error'
  | 'image-capacity'

export interface TilesDiagnostic {
  readonly code: TilesErrorCode
  readonly message: string
  readonly stage: 'root' | 'hierarchy' | 'request' | 'decode' | 'runtime' | 'dispose'
  readonly sourceUrl?: string
  readonly assetId?: string
  readonly tileId?: string
  readonly contentId?: string
  readonly extension?: string
  readonly retryable?: boolean
}

/** 可序列化来源信息和可重试分类，不依赖 Three 或解码器。 */
export class TilesError extends Error {
  readonly diagnostic: TilesDiagnostic

  constructor(diagnostic: TilesDiagnostic, options?: ErrorOptions) {
    super(diagnostic.message, options)
    this.name = 'TilesError'
    this.diagnostic = Object.freeze({ ...diagnostic })
  }
}

export function throwIfTilesAborted(signal?: AbortSignal): void {
  if (signal?.aborted) {
    throw new TilesError({ code: 'cancelled', stage: 'request', message: 'Tiles 请求已取消' })
  }
}

export function toTilesDiagnostic(
  error: unknown,
  context: Partial<TilesDiagnostic> = {}
): TilesDiagnostic {
  if (error instanceof TilesError) return { ...context, ...error.diagnostic }
  const cancelled = error instanceof Error && error.name === 'AbortError'
  return {
    code: cancelled ? 'cancelled' : 'invalid-resource',
    stage: 'runtime',
    message: error instanceof Error ? error.message : String(error),
    ...context,
  }
}
